var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import { Bling as GPT } from "react-gpt";

export default function Ad(_ref) {
  var adUnit = _ref.adUnit,
      props = _objectWithoutProperties(_ref, ["adUnit"]);

  return React.createElement(GPT, _extends({
    adUnitPath: "/227892952/axios/" + adUnit
  }, props));
}

Ad.propTypes = {
  adUnit: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Library/Ad/Ad.js